import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import Loader from 'src/comps/Atom/Loader'
import useWindowMessage from 'src/hooks/useWindowMessage'
import { PAYMENT_FAIL_EVENT, PAYMENT_SUCCESS_EVENT } from 'client/pages/Payment/constants'
import { PaymentOgoneBase, Iframe } from './styles'

import PrimaryButton from 'src/comps/Atom/Buttons/PrimaryButton'
import messages from './messages'

const PaymentOgone = ({ src, onSuccess, onError, onBeforeSubmit, disabled, customSubmit }) => {
  const ref = useRef()
  const [isLoading, setIsLoading] = useState(true)
  const [isSubmitting, setIsSubmitting] = useState(false)

  /* istanbul ignore next */
  useEffect(() => {
    if (!isLoading && ref?.current?.contentWindow) {
      ref.current.contentWindow.postMessage(disabled ? 'disable' : 'enable', src)
    }
  }, [disabled, isLoading, ref, src])

  function handleOnLoad() {
    setIsLoading(false)
  }

  function handleIframe(e) {
    const event = e?.data

    if (event === PAYMENT_SUCCESS_EVENT) {
      onSuccess()
    }

    if (event?.status === PAYMENT_SUCCESS_EVENT) {
      onSuccess(event?.data)
    }

    if (event === PAYMENT_FAIL_EVENT || event?.status === PAYMENT_FAIL_EVENT) {
      setIsSubmitting(false)
      onError()

      if (ref.current?.src) {
        ref.current.src = src // reset iframe
      }
    }
  }

  async function handleSumit(event) {
    event.preventDefault()
    if (typeof onBeforeSubmit === 'function') {
      setIsSubmitting(true)
      if (!(await onBeforeSubmit())) {
        setIsSubmitting(false)
        return
      }
      setIsSubmitting(false)
    }
    ref.current.contentWindow.postMessage('submit', src)
  }

  useWindowMessage(handleIframe)

  return (
    <PaymentOgoneBase>
      {isLoading && <Loader />}
      <Iframe
        data-testid="payment-iframe"
        id="payment-form-iframe"
        onLoad={handleOnLoad}
        ref={ref}
        src={src}
        title="payment"
        customSubmit={customSubmit}
      />
      {customSubmit && (
        <PrimaryButton
          data-testid="payment-custom-submit"
          disabled={isLoading || disabled || isSubmitting}
          onClick={handleSumit}
          fullWidth
        >
          <FormattedMessage {...messages.confirmBooking} />
        </PrimaryButton>
      )}
    </PaymentOgoneBase>
  )
}

PaymentOgone.propTypes = {
  onError: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  onBeforeSubmit: PropTypes.func,
  src: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  customSubmit: PropTypes.bool,
}

export default PaymentOgone
